import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const a = "feedback/feedback_reply_suggestion";
class n extends s {
  /**
   * Get the Feedback reply suggestion prompt for the given org
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_reply_suggestion/prompt/:org_id`
   *
   * @param {number} orgId
   */
  async getPrompt(t) {
    const { data: e } = await this.get(
      `${a}/prompt/${t}`
    );
    return e;
  }
  /**
   * Get the generic Feedback reply suggestion prompt
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_reply_suggestion/prompt`
   */
  async getGenericPrompt() {
    const { data: t } = await this.get(
      `${a}/prompt`
    );
    return t;
  }
  /**
   * Updates the Feedback reply suggestion prompt for the given org
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/feedback/feedback_reply_suggestion/prompt/:org_id`
   *
   * @param {number} orgId
   * @param {UpdateFeedbackReplySuggestionPromptPayload} payload
   */
  async updatePrompt(t, e) {
    const { data: r } = await this.put(
      `${a}/prompt/${t}`,
      e
    );
    return r;
  }
  /**
   * Updates the generic Feedback reply suggestion prompt
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/feedback/feedback_reply_suggestion/prompt`
   *
   * @param {UpdateFeedbackReplySuggestionPromptPayload} payload
   */
  async updateGenericPrompt(t) {
    const { data: e } = await this.put(
      `${a}/prompt`,
      t
    );
    return e;
  }
  /**
   * Deletes the Feedback reply suggestion prompt for the given org
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/feedback/feedback_reply_suggestion/prompt/:org_id`
   *
   * @param {number} orgId
   */
  async deletePrompt(t) {
    const { data: e } = await this.delete(`${a}/prompt/${t}`);
    return e;
  }
}
export {
  n as FeedbackReplySuggestion
};
